import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid } from 'semantic-ui-react';

import { AccountManage, Commons } from 'components';

import * as cm_action from 'actions/commons';
import * as cp_action from 'actions/company';
import * as etc_action from 'actions/etc';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';

const propTypes = {};

const defaultProps = {};

const CORP_APPLICATION_NAME = 'corp-api'

class AccountManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: null,
      page: 1,
      pageRow: 15,
      pageType: 'list',
      staffInfo: false,
      confirmShow: false,
      confirmName: null
    };
  }

  componentWillMount() {
    let comInfo = (storage.get('company') || {}).info;
    if (!(comInfo || {}).isAdminAuth) {
      this.context.router.history.push('/service/landing');
      return <div></div>;
    }
    const { keyowrd, page, pageRow } = this.state;
    const { history } = this.context.router;
    const params = { keyowrd, page, pageRow };

    this.authStaffSel(params);
    this.presetSel();

    if (history.location.state) {
      const { authInfo } = this.props;

      if (authInfo && authInfo.value) {
        this.modStaffPage(authInfo.value);
      }
    }
  }

  componentDidMount() {
    cm.mainTitle('관리자 권한 관리');
  }

  //권한관리 계정 페이지로 전환
  addAuthPage = () => {
    this.setState({ pageType: 'add' });
  };

  //권한 사용자 조회
  authStaffSel = async (params) => {
    const { etcAPI } = this.props;

    try {
      await etcAPI.authStaffSel(params);
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### divisionUserCntSel error : ', e);
    } finally {
    }
  };

  //권한 목록 조회
  presetSel = () => {
    const { cmAPI } = this.props;

    try {
      cmAPI.presetSel('');
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### presetSet error : ', e);
    } finally {
    }
  };

  //사용자 조회
  staffSel = async (page, keyword) => {
    const { cmAPI } = this.props;

    const params = {
      page: page,
      pagerow: 10,
      keyword: keyword
    };

    try {
      await cmAPI.staffSel(params);
    } catch (e) {
      const response = e.response;
      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### staffSel error : ', e);
    } finally {
    }
  };

  //사용자 정보 변경페이지
  modStaffPage = async (data) => {
    const { etcAPI } = this.props;

    try {
      const params = {
        id: data.id
      };

      if (params.id) {
        await etcAPI.authStaffDet(params);

        this.setState({
          pageType: 'mod',
          staffInfo: data
        });
      } else {
        toastr('top-right', 'warning', '회원 아이디가 존재하지 않습니다.');
        return;
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### modStaffPage error : ', e);
    } finally {
    }
  };

  //권한 사용자 추가
  authStaffAdd = async (params) => {
    const { page, pageRow } = this.state;
    const { etcAPI } = this.props;

    try {
      await etcAPI.authStaffAdd(params);
      await this.authStaffSel({ page, pageRow });
      this.setState({ pageType: 'list' });

      toastr('top-right', 'success', '권한이 추가 되었습니다.');
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### authStaffAdd error : ', e);
    } finally {
    }
  };

  //권한 사용자 변경
  authStaffMod = async (params) => {
    const { page, pageRow } = this.state;
    const { etcAPI, cpAPI } = this.props;

    try {
      await etcAPI.authStaffMod(params);

      const { authStaffMod } = this.props;

      let id = params.id;

      if (authStaffMod && authStaffMod.status === 200) {
        await this.logOutFunc(id);
        await this.authStaffSel({ page, pageRow });
        this.setState({ pageType: 'list' });

        toastr('top-right', 'success', '변경 되었습니다.');
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### authStaffMod error : ', e);
    } finally {
    }
  };

  //권한 사용자 삭제
  authStaffDel = async (params) => {
    const { page, pageRow } = this.state;
    const { etcAPI } = this.props;

    try {
      await etcAPI.authStaffDel(params);

      const { authStaffDel } = this.props;
      let id = params.id;

      if (authStaffDel && authStaffDel.status === 204) {
        await this.logOutFunc(id);
        await this.authStaffSel({ page, pageRow });

        toastr('top-right', 'success', '권한이 삭제 되었습니다.');
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### authStaffDel error : ', e);
    } finally {
    }
  };

  logOutFunc = async (id) => {
    const { cpAPI } = this.props;
    const params = {
      applicationName: CORP_APPLICATION_NAME
    };

    try {
      await cpAPI.logOut(id, params);
      const { logout } = this.props;

      // 로그아웃 token이 존재 할 시
      if (logout && logout.data.tokens.length > 0) {
        const { tokens } = logout.data;

        tokens.forEach(async (data) => {
          await cpAPI.logOutStepTwo({ token: data });
        });
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### authStaffDel error : ', e);
    } finally {
    }
  };

  //삭제 팝업 노출
  confirmOpen = async (isOpen, result, staff) => {
    this.setState({
      confirmShow: isOpen,
      confirmName: isOpen ? staff.name : null
    });

    if (isOpen) {
      this.setState({ delStaff: staff });
    } else {
      this.setState({ delStaff: null });
    }

    const { delStaff } = this.state;

    if (result) {
      const params = {
        id: delStaff.id,
        orgCode: delStaff.auth.organization
      };

      this.authStaffDel(params);
    }
  };

  // 키워드 검색
  changeText = async (e) => {
    await this.setState({ keyword: e.target.value });
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  submitForm = (e) => {
    e.preventDefault();

    const { keyword, page, pageRow } = this.state;
    const params = {
      keyword,
      page,
      pageRow
    };

    this.authStaffSel(params);
  };

  // 페이지 이동
  pageClick = async (pageNum) => {
    await this.setState({ page: pageNum });

    const { keyword, page, pageRow } = this.state;
    const params = {
      keyword,
      page,
      pageRow
    };

    this.authStaffSel(params);
  };

  render() {
    const { pageType, staffInfo, confirmShow, confirmName, keyword } = this.state;
    const fn = {
      authStaffList: {
        modStaffPage: this.modStaffPage,
        confirmOpen: this.confirmOpen,
        pageClick: this.pageClick
      },

      authStaffListSearch: {
        handleSubmit: this.submitForm,
        handleEntSubmit: this.handleEntSubmit,
        handleChange: this.changeText
      },

      addAuth: {
        staffSel: this.staffSel,
        authStaffAdd: this.authStaffAdd
      },

      modAuth: {
        authStaffMod: this.authStaffMod
      }
    };

    const data = {
      modAuth: {
        staffInfo: staffInfo
      }
    };

    const confirmStyle = {
      width: '660px',
      fontSize: '16px',
      fontWeight: 'bold'
    };
    let dom = null;

    switch (pageType) {
      case 'list':
        dom = (
          <div>
            <AccountManage.AuthStaffSearchForm keyword={keyword} fn={fn.authStaffListSearch} />
            <AccountManage.AuthStaffList fn={fn.authStaffList} />
          </div>
        );
        break;
      case 'add':
        dom = <AccountManage.AddAuth fn={fn.addAuth} />;
        break;
      case 'mod':
        dom = <AccountManage.ModAuth fn={fn.modAuth} data={data.modAuth} />;
        break;
      default:
    }

    return (
      <main className="am">
        <Commons.ConfirmContent
          openFunc={this.confirmOpen}
          confirmShow={confirmShow}
          style={confirmStyle}
          text={confirmName + '의 권한을 삭제하시겠습니까? 일반사용자로 변경됩니다.'}
          cancelButton={'아니요'}
          confirmButton={'삭제하기'}
        />
        <div className="top-btn button">
          {pageType === 'list' ? (
            <Button.Group>
              <Button inverted color="black" onClick={this.addAuthPage}>
                권한관리 계정 추가하기
              </Button>
            </Button.Group>
          ) : null}
        </div>
        <div>{dom}</div>
      </main>
    );
  }
}

AccountManagement.propTypes = propTypes;
AccountManagement.defaultProps = defaultProps;

AccountManagement.contextTypes = {
  router: PropTypes.object.isRequired
};

AccountManagement = connect(
  (state) => ({
    authInfo: state.commons.authInfo,
    authStaffMod: state.etc.authStaffMod,
    authStaffDel: state.etc.authStaffDel,
    logout: state.company.logout
  }),
  (dispatch) => ({
    etcAPI: bindActionCreators(
      {
        authStaffSel: etc_action.AuthStaffSel,
        authStaffAdd: etc_action.AuthStaffAdd,
        authStaffMod: etc_action.AuthStaffMod,
        authStaffDet: etc_action.AuthStaffDet,
        authStaffDel: etc_action.AuthStaffDel
      },
      dispatch
    ),

    cmAPI: bindActionCreators(
      {
        presetSel: cm_action.PresetSel,
        staffSel: cm_action.StaffSel
      },
      dispatch
    ),

    cpAPI: bindActionCreators(
      {
        logOut: cp_action.Logout,
        logOutStepTwo: cp_action.LogoutStepTwo
      },
      dispatch
    )
  })
)(AccountManagement);

export default AccountManagement;
